import styled, { css } from 'styled-components'
import { Text, ArrowRight } from 'vvs-uikit'

export const CalculatorPageHeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.darkPurple};
  width: 100%;
`

export const CalculatorPageHeader = styled.div`
  max-width: 1200px;
  min-height: 346px;
  background-color: ${({ theme }) => theme.colors.darkPurple};
  padding: 48px 24px 156px 24px;
  margin: 0 auto;
  position: relative;
`

export const RocketMole = styled.img`
  position: absolute;
  top: 32px;
  right: 5%;
  width: 38vw;
  max-width: 557px;
  display: none;

  ${({ theme }) => theme.mediaQueries.xxl} {
    display: inline-block;
  }
`

export const CalculatorPageContent = styled.div`
  max-width: 1200px;
  padding: 0px 24px 136px 24px;
  margin: 0 auto;
  display: flex;
  gap: 36px;
  align-items: center;
  width: 100%;
  flex-direction: column;
  position: absolute;
  top: -100px;
  left: 0;
  right: 0;

  ${({ theme }) => theme.mediaQueries.xxl} {
    gap: 40px;

    flex-direction: row;
    align-items: stretch;
  }
`

export const CardWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-width: 345px;
  max-width: 500px;
  border-radius: 18px;

  ${({ theme }) => theme.mediaQueries.xxl} {
    min-width: 520px;
    max-width: 550px;
  }
`

export const ArrowIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledArrowRight = styled(ArrowRight)`
  width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.colors.text};
  transform: rotate(90deg);

  ${({ theme }) => theme.mediaQueries.xxl} {
    transform: rotate(0deg);
  }
`

export const TitleStyle = css`
  font-family: 'Soleil';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.darkestNightBlue};
`

export const DescStyle = css`
  ${TitleStyle}
  font-weight: 350;
  font-size: 13px;
  line-height: 18px;
`
export const TokenPairText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text};
  margin-left: 10px;
`

export const TokenWrapper = styled.div`
  top: 4px;
  position: relative;
  padding-right: 8px;
  width: 50px;
`
